import { useIsDesktop } from "common/MediaQueries"
import ContentWithForm from "reusable/ContentWithForm"
import { getRecalls } from "../../api/delek"
import { ButtonType, ContentItemType } from "../../typings/contentPage"

const RecallPage = () => {
  const buttons: ButtonType[] = [
    { value: "licenseNumber", name: "מס׳ לוחית רישוי" },
    { value: "chassis", name: "מס׳ שלדה" },
  ]

  const isDesktop = useIsDesktop()

  const headerText = !isDesktop
    ? [
        "קריאה חוזרת הינה פניה יזומה של יצרן הרכב אל בעל הרכב שמטרתה ביצוע ללא דיחוי של בדיקה ו/או פעולה מונעת ו/או תיקון ברכב לפי מקרה.",
      ]
    : [
        `קריאה חוזרת הינה פניה יזומה של יצרן הרכב אל בעל הרכב שמטרתה ביצוע ללא דיחוי של בדיקה ו/או פעולה`,
        ` מונעת ו/או תיקון ברכב לפי מקרה.`,
      ]

  return (
    <ContentWithForm
      title="קריאות חוזרת (RECALL)"
      headerText={headerText}
      background={["/img/recallsmobile.jpg", "/img/recalls.jpg"]}
      subtitle="כדי לבדוק אם קיימת בקשה לקריאה חוזרת למאזדה שלך, יש להקליד כאן את מספר לוחית הרישוי או השלדה"
      buttons={buttons}
      inputLabel={`לוחית רישוי (משמאל לימין)`}
      inputType="text"
      submitText="לבדיקה"
      bottomTitle="שירות הלקוחות שלנו זמין בשבילך לכל עניין:"
      phoneNumber="*2880"
      bottomSubTitle="על פי תקנה 306 א לתקנות התעבורה, משרד התחבורה לא יחדש את רישיון הרכב ולא יאפשר העברת בעלות ברכב שבעליו לא יבצע בפועל את תיקון תקלת הבטיחות הסדרתית תוך 6 חודשים ממועד קבלת מכתב ממשרד התחבורה בעניין זה."
      getData={getRecalls}
      type={ContentItemType.RECALL}
      page={"recall"}
      breadCrumbName="Recall"
    />
  )
}

export default RecallPage
